import { Route as PurchaseInvoiceRoute } from "@/routes/(pharma)/_layout/reports/purchase-invoice-list/index";
import { useQuery } from "@tanstack/react-query";
import { getPurchaseInvoices, getSuppliers } from "../-data/api";

interface PurchaseInvoiceQueryResult {
  invoices: any[];
  suppliers: any[];
  supplierId?: string;
  purchaseInvoiceCount: number;
}

export const usePurchaseInvoiceData = () => {
  const searchParams = PurchaseInvoiceRoute.useSearch();
  
  return useQuery<PurchaseInvoiceQueryResult>({
    queryKey: ["purchase-invoices", searchParams],
    queryFn: async () => {
      const suppliers = await getSuppliers();
      
      if (searchParams.open_supplier_picker) {
        return {
          invoices: [],
          suppliers: suppliers,
          purchaseInvoiceCount: 0,
        };
      }
      
      const response = await getPurchaseInvoices(
        searchParams.page || 1,
        searchParams.pageSize || 10,
        searchParams.supplierID
      );
      
      return {
        invoices: response.invoices,
        suppliers: suppliers,
        supplierId: searchParams.supplierID,
        purchaseInvoiceCount: response.totalCount,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};